import React, { useState } from "react";
import "./Setting.css"; // Import CSS file for modal styling

const Setting = ({ isOpen, onClose, onSave, workTime, breakTime, breakMsg, workMsg, onChangeWorkTime, onChangeWorkMsg, onChangeBreakMsg, onChangeBreakTime, theme, handleThemeChange }) => {
  const handleSave = () => {
    onSave();
    onClose();
  };

  return (
    <div className={`modal ${isOpen ? "open" : ""}`}>
      <div className="modal-content">
        <h2 className="modal-title">Settings</h2>
        <form className="modal-form">
          <label htmlFor="workTimeInput" className="modal-label">
            Work Time (minutes)
          </label>
          <input
            id="workTimeInput"
            type="number"
            className="modal-input"
            value={workTime}
            onChange={onChangeWorkTime}
          />
          <label htmlFor="workMsgInput" className="modal-label">
            Work Msg.
          </label>
          <input
            id="workMsgInput"
            type="text"
            className="modal-input"
            value={workMsg}
            onChange={onChangeWorkMsg}
          />
          <label htmlFor="breakTimeInput" className="modal-label">
            Break Time (minutes)
          </label>
          <input
            id="breakTimeInput"
            type="number"
            className="modal-input"
            value={breakTime}
            onChange={onChangeBreakTime}
          />
          <label htmlFor="breakMsgInput" className="modal-label">
            Break Msg.
          </label>
          <input
            id="breakMsgInput"
            type="text"
            className="modal-input"
            value={breakMsg}
            onChange={onChangeBreakMsg}
          />
          <label htmlFor="themeToggle" className="modal-label">
            Dark Theme
          </label>
          <label className="switch">
            <input
                id="themeToggle"
                type="checkbox"
                checked={theme}
                onChange={handleThemeChange}
            />
            <span className="slider round"></span>
            </label>
          <button type="button" className="modal-btn" onClick={handleSave}>
            Save
          </button>
          <button type="button" className="modal-btn" onClick={onClose}>
            Close
          </button>
        </form>
      </div>
    </div>
  );
};

export default Setting;
